import React from 'react'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'
import { Link } from 'react-router-dom'

const steps = [
  { title: 'Upload', text: 'Gehe zu „Upload“ und lade deine Audiospur (WAV oder FLAC) hoch.' },
  { title: 'Warten auf Analyse & Mastering', text: 'Der Track wird analysiert und automatisch gemastert. Fortschritt siehst du in der Job-Liste und auf der Track-Detailseite.' },
  { title: 'Track öffnen', text: 'Klicke auf den Track (Dashboard oder „Masters“), um Details, Wellenform und Downloads zu sehen.' },
  { title: 'Downloads', text: 'Nach dem Mastering: WAV und MP3 herunterladen, optional Report (TXT) und Cover (PNG). Bei Bedarf „Cover generieren“ oder „Canvas generieren“ nutzen.' },
  { title: 'Cover', text: 'Cover generieren: Wähle „Ja“ für Titel/Künstler exakt auf dem Cover oder „Nein“ nur für das Bild. Optional einen Design-Prompt angeben.' },
  { title: 'Canvas (Spotify-Style)', text: 'Canvas generieren: Wähle Bild oder Video, optional Design-Prompt. Das Ergebnis passt zu Titel und Song und kann z. B. bei Spotify als Canvas genutzt werden.' },
  { title: 'Metadaten', text: 'Titel, Künstler, Album, Genre etc. auf der Track-Detailseite anpassen; bei Bedarf „Metadaten vorschlagen“ nutzen.' },
]

export default function Anleitung() {
  return (
    <PageShell>
      <SectionTitle title="Anleitung" />
      <Card className="mt-4 space-y-6">
        <p className="text-sm text-white/80">
          So nutzt du das AI Mastering Studio: Upload → Mastering abwarten → Track öffnen → Dateien herunterladen, optional Cover und Canvas erzeugen.
        </p>
        <ol className="space-y-4 list-none">
          {steps.map((step, i) => (
            <li key={i} className="flex gap-4">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-violet-500/20 text-violet-300 text-sm font-semibold">
                {i + 1}
              </span>
              <div>
                <h3 className="text-sm font-medium text-white mb-1">{step.title}</h3>
                <p className="text-sm text-white/75 leading-relaxed">{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
        <p className="text-sm text-white/60 pt-2">
          Weitere Fragen? Siehe <Link to="/dashboard/faq" className="text-violet-300 hover:text-violet-200 underline">FAQ</Link> und <a href="https://anwendungen.online" target="_blank" rel="noopener noreferrer" className="text-violet-300 hover:text-violet-200 underline">anwendungen.online</a>.
        </p>
      </Card>
    </PageShell>
  )
}
